/**
 * Le lien « Voir le modèle » d'un historique d'e-mails.
 *
 * Deux conditions pour qu'il s'affiche : le type d'e-mail doit correspondre à
 * un modèle de l'aperçu, et l'utilisateur doit avoir le droit de voir ce
 * modèle. Un commercial ne voit que les modèles atteignables depuis ses fiches
 * (cf. src/constants/emailPreviewAudience.js) — sans ce filtre, l'historique
 * d'une fiche formateur lui proposerait des liens qui finissent en refus.
 *
 * Le serveur reste l'autorité : il filtre le catalogue et refuse la génération
 * d'un modèle interdit. Ce composable ne fait que ne pas proposer l'impasse.
 */
import { usePermissions } from '../auth/usePermissions.js'
import { getEmailPreviewTemplateId } from '../../utils/formatting.js'
import { canPreviewEmailTemplate } from '../../constants/emailPreviewAudience.js'
import { ROLES } from '../../constants/roles.js'

export function useEmailPreviewLink() {
  const { isAdmin } = usePermissions()

  /**
   * Id du modèle à prévisualiser pour ce type d'e-mail, ou null si le type
   * n'est pas mappé ou si l'utilisateur n'a pas accès au modèle.
   */
  const previewTemplateId = (emailType) => {
    const templateId = getEmailPreviewTemplateId(emailType)
    if (!templateId) return null
    const role = isAdmin.value ? ROLES.ADMIN : ROLES.COMMERCIAL
    return canPreviewEmailTemplate(role, templateId) ? templateId : null
  }

  /**
   * Destination du lien, devis d'origine compris quand il y en a un : l'aperçu
   * se remplit alors avec la vraie demande plutôt qu'avec l'exemple.
   */
  const previewLink = (email) => {
    const query = { template: previewTemplateId(email.email_type) }
    if (email.quote_id) {
      query.quoteId = String(email.quote_id)
    }
    return { path: '/email-templates-preview', query }
  }

  return { previewTemplateId, previewLink }
}
